import script from "./betCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./betCard.vue?vue&type=script&setup=true&lang=ts"

import "./betCard.vue?vue&type=style&index=0&id=59bc1e24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bc1e24"]])

export default __exports__